/**
 * This file is part of Discorch.
 * Copyright (C) 2025 Discorch Contributors.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import discordPoster from "@/assets/discord-data-package-poster.webp";
import discordVideo from "@/assets/discord-data-package.webm";
import {
  MediaControlBar,
  MediaController,
  MediaFullscreenButton,
  MediaPlayButton,
  MediaTimeDisplay,
  MediaTimeRange,
} from "media-chrome/react";

export function GuideVideo() {
  return (
    <MediaController className="aspect-1000/750 w-full overflow-hidden rounded-lg border">
      <video
        slot="media"
        src={discordVideo}
        poster={discordPoster}
        preload="none"
        crossOrigin="anonymous"
        className="h-full w-full object-cover"
      />
      <MediaControlBar>
        <MediaPlayButton />
        <MediaTimeRange />
        <MediaTimeDisplay showDuration />
        <MediaFullscreenButton />
      </MediaControlBar>
    </MediaController>
  );
}
